import {
  EventScenarioCreated,
  LeaderboardResponse,
  ScenarioCopyRequest,
  ScenarioDetails,
  ScenarioUpdate,
  ScenarioWithRoomsAndStages,
} from '../types';

import axiosInstance from './axiosInstance';

export async function getScenario(scenarioUuid: string) {
  const response = await axiosInstance.get(`/scenarios/${scenarioUuid}`);
  return response.data as ScenarioWithRoomsAndStages;
}

export async function getScenarioDetails(scenarioUuid: string) {
  const response = await axiosInstance.get(`/scenarios/${scenarioUuid}/details`);
  return response.data as ScenarioDetails;
}

export async function updateScenario(scenarioUuid: string, update: ScenarioUpdate) {
  await axiosInstance.put(`/scenarios/${scenarioUuid}`, update);
}

export async function getLeaderboard(scenarioUuid: string) {
  const response = await axiosInstance.get(`/scenarios/${scenarioUuid}/leaderboard`);
  return response.data as LeaderboardResponse;
}

export async function copyScenario(scenarioUuid: string, req: ScenarioCopyRequest) {
  const response = await axiosInstance.post(`/scenarios/${scenarioUuid}/copy`, req);
  return response.data as EventScenarioCreated;
}
